module.exports = __webpack_public_path__ + "img/avantage.b8abff41.svg";